<template>
  <wgu-module-card v-bind="$attrs" moduleName="wgu-layerlistcustom" class="wgu-layerlistcustom" :icon="icon"
    :moduleLabel="topicName">
    <!--
    <template v-slot:wgu-win-toolbar>
      <img height="60" :src="postImageSrc" class="d-none d-sm-flex" />
    </template>
    -->
    <template v-slot:wgu-win-toolbar-additionalIcon>
        <component :is="toolbarButtons[0].type" large :key="toolbarButtons[0].moduleName" v-bind="toolbarButtons[0]" />
    </template>

    <wgu-layerlisthochwasser v-if="this.topicName === 'Hochwasser'" :showLegends="showLegends"
      :showOpacityControls="showOpacityControls" layersTopicName="Hochwasser" />

    <wgu-layerlistgrundwasser v-if="this.topicName === 'Grundwasser'" :showLegends="showLegends"
      :showOpacityControls="showOpacityControls" layersTopicName="Grundwasser" />

    <wgu-layerliststarkregen v-if="this.topicName === 'Starkregen'" :showLegends="showLegends"
      :showOpacityControls="showOpacityControls" layersTopicName="Starkregen" />
  </wgu-module-card>
</template>

<script>
import Vue from 'vue';
import ModuleCard from './../../../src/components/modulecore/ModuleCard';
import LayerListHochwasser from './LayerListHochwasser';
import LayerListGrundwasser from './LayerListGrundwasser';
import LayerListStarkregen from './LayerListStarkregen';
import InfoButton from '../InfoButton/InfoButton.vue'
import { Mapable } from '../../../src/mixins/Mapable';

import { WguEventBus } from '../../../src/WguEventBus';

export default {
  name: 'wgu-layerlistcustom-win',
  inheritAttrs: false,
  components: {
    'wgu-module-card': ModuleCard,
    'wgu-layerlisthochwasser': LayerListHochwasser,
    'wgu-layerlistgrundwasser': LayerListGrundwasser,
    'wgu-layerliststarkregen': LayerListStarkregen,
    'wgu-infobutton-btn': InfoButton
  },
  mixins: [Mapable],
  props: {
    icon: { type: String, required: false, default: 'layers' },
    showLegends: { type: Boolean, required: false, default: true },
    showOpacityControls: { type: Boolean, required: false, default: false }
  },
  created () {
    WguEventBus.$on('layerList-topicButton', this.changeTopicName);
  },
  data () {
    const urlObj = new URL(window.location.href)

    if (urlObj.searchParams.get('Module')) {
      if (this.$appConfig.TopicList.indexOf(urlObj.searchParams.get('Module')) >= 0) {
        this.$appConfig.TopicDefault = urlObj.searchParams.get('Module')
      }
    }

    return {
      layers: [],
      topicName: this.$appConfig.TopicDefault,
      topicNameLast: null,
      postImageSrc: './static/icon/symbolHochwasser.png',
      toolbarButtons: this.getModuleButtons('toolbar')
    }
  },
  methods: {
    onMapBound () {
      this.layers = this.map.getLayers().getArray();

      // TODO initiales Setzen bei moduleName übergabe überprüfen!
      if (this.topicName !== 'Hochwasser') {
        this.storeLayerVisibility('Hochwasser')
      }
      if (this.topicName !== 'Grundwasser') {
        this.storeLayerVisibility('Grundwasser')
      }
      if (this.topicName !== 'Starkregen') {
        this.storeLayerVisibility('Starkregen')
      }
    },
    changeTopicName (t) {
      this.topicNameLast = this.topicName
      this.topicName = t;
      this.postImageSrc = './static/icon/symbol' + t + '.png';

      this.storeLayerVisibility(this.topicNameLast);

      this.restoreLayerVisibility(this.topicName);
    },
    storeLayerVisibility (lastTopicName) {
      const layersToStore = this.layers.filter(layer => layer.get('displayInLayerList') !== false && !layer.get('isBaseLayer') && layer.get('layerGroup') === lastTopicName)

      layersToStore.forEach(l => {
        // console.log(l.get('lid'));
        // console.log(l.getVisible());
        // console.log(l.get('visibleLastState'));
        l.set('visibleLastState', l.getVisible())
        l.setVisible(false)
        // console.log(l.getVisible());
        // console.log(l.get('visibleLastState'));
      });
    },
    restoreLayerVisibility (newTopicName) {
      const layersToRestore = this.layers.filter(layer => layer.get('displayInLayerList') !== false && !layer.get('isBaseLayer') && layer.get('layerGroup') === newTopicName)

      layersToRestore.forEach(l => {
        // console.log(l.get('lid'));
        // console.log(l.getVisible());
        // console.log(l.get('visibleLastState'));
        l.setVisible(l.get('visibleLastState'))
        // console.log(l.getVisible());
      });
    },
    getModuleButtons (target) {
      const appConfig = Vue.prototype.$appConfig || {};
      const modulesConfs = appConfig.modules || {};
      const buttons = [];
      for (const key of Object.keys(modulesConfs)) {
        const moduleOpts = appConfig.modules[key];

        if (key === 'wgu-infobutton') {
          buttons.push({
            type: moduleOpts.win ? 'wgu-toggle-btn' : key + '-btn',
            large: true,
            moduleName: key,
            ...moduleOpts
          });
        }
      }

      return buttons;
    }
  }
}
</script>
